import React from "react"
import { Header, Segment } from "semantic-ui-react"

export const NewTiresWidget = ({
  icon,
  link,
  linkText,
  linkClick,
  title,
  description,
  iconSize
}) => {
  return (
    <>
      <span />
      <Header size="small" className={"dash-hd hide-margin-on-computer-up"}>
        {title}
      </Header>
      <Segment className="flex-grow-1 flex flex-col justify-between">
        <div className="bg-neutral-100 p-3 flex items-center justify-center mx-auto rounded w-full">
          <div className={`${iconSize ? iconSize : "size-40"} flex items-center justify-center`}>
            {icon}
          </div>
        </div>
        <p className="text-gray-600 m-0">{description}</p>
        {(link || linkClick) && (
          <div className="flex items-center justify-between">
            {link && (
              <a
                href={link}
                className="link hover:text-red-700 font-medium underline"
                onClick={linkClick}
                target="_blank"
              >
                {linkText}
              </a>
            )}
            {linkClick && (
              <p className="link hover:text-red-700 font-medium underline" onClick={linkClick}>
                {linkText}
              </p>
            )}
          </div>
        )}
      </Segment>
    </>
  )
}
